import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgV2FilledComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "18px",
	height: "18px",
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-878.000000, -294.000000)",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2,
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(853.000000, 291.000000)",
				children: /* @__PURE__ */ _jsx("path", { d: "M42,14.6666667 C42,15.6485062 41.2040618,16.4444444 40.2222222,16.4444444 L29.5555556,16.4444444 L26,20 L26,5.77777778 C26,4.79593822 26.7959382,4 27.7777778,4 L40.2222222,4 C41.2040618,4 42,4.79593822 42,5.77777778 L42,14.6666667 Z" })
			})
		})
	})
});
export default SvgV2FilledComment;
